import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const FormLabel = styled.span`
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    line-height: 16px;
    color: ${Colors.Black.V50};
`;
